import { cn } from '#/shared/lib/utils'

import { CAMPAIGN_TONES } from '../lib/campaign-tone'
import type { CampaignTone } from '../lib/campaign-tone'

const SIZE_CLASS = {
  lg: 'text-2xl',
  md: 'text-xl',
} as const

export type CampaignStatSize = keyof typeof SIZE_CLASS

interface CampaignStatProps {
  value: string
  label: string
  note?: string
  size?: CampaignStatSize
  /** Ink of the headline number. Defaults to the plain text colour. */
  tone?: CampaignTone
  /** Ink of the note line. Defaults to the faint grey. */
  noteTone?: CampaignTone
}

/** Headline figure, its name, and a qualifying line — the detail's unit of stat. */
export function CampaignStat({
  value,
  label,
  note,
  size = 'lg',
  tone = 'default',
  noteTone = 'faint',
}: CampaignStatProps) {
  return (
    <div className="flex min-w-0 flex-1 flex-col gap-1">
      <p
        className={cn(
          'truncate font-semibold',
          SIZE_CLASS[size],
          CAMPAIGN_TONES[tone],
        )}
      >
        {value}
      </p>
      <p className="truncate text-xs font-medium text-gray-900">{label}</p>
      {note != null && (
        <p className={cn('truncate text-xs', CAMPAIGN_TONES[noteTone])}>
          {note}
        </p>
      )}
    </div>
  )
}
